import React from 'react'
import Navbar from '../Components/Navbar'
import HomepageHero from '../Components/HomepageHero'
import OurServices from '../Components/Our Services'
import WhyChooseUs from '../Components/WhyChooseUs'
import IndustryExpertise from '../Components/IndustryExpertise'
import HomepageContent from '../Components/HomepageContent'
import How from '../Components/How'
import Testimonial from '../Components/Testimonial'
import FAQ from '../Components/FAQ'
import Footer from '../Components/Foooter'
import PremiumInfluencer from '../Components/Influencer/PremiumInfluencer'
import SmsOTPStandalone from '../Components/PhoneVerification/SmsOTPStandalone'
import OrganizationSchema from '../Components/SEO/OrganizationSchema'
import PageSEO from '../Components/SEO/PageSEO'
import PersistentCTA from '../Components/CRO/PersistentCTA'
import StickyMobileCTA from '../Components/CRO/StickyMobileCTA'

const Homepage = () => {
  return (
    <div>
      <PageSEO 
        title="Top Digital Marketing Company In Ramamurthy Nagar | Digital Marketing Services In Ramamurthy Nagar – Cyborgsapient Pvt. Ltd."
        description="Looking for expert digital marketing services in Ramamurthy Nagar? Cyborgsapient Pvt. Ltd. provides result-driven SEO, SMO, PPC, and online marketing solutions for businesses."
        keywords="digital marketing company in Bangalore, SEO services in Bangalore, SEO company near me, best digital marketing agency in Bangalore, website development company Bangalore, social media marketing Bangalore, Google Ads agency Bangalore, local SEO services Bangalore, digital marketing agency near me, affordable SEO services Bangalore, SEO expert in Bangalore, PPC services Bangalore, app development company Bangalore, lead generation company Bangalore, best SEO company in Bangalore, digital marketing company in Ramamurthy Nagar, SEO services in Ramamurthy Nagar, best digital marketing agency in Ramamurthy Nagar, website development company Ramamurthy Nagar, social media marketing Ramamurthy Nagar, Google Ads agency Ramamurthy Nagar, local SEO services Ramamurthy Nagar, affordable SEO services Ramamurthy Nagar, SEO expert in Ramamurthy Nagar, PPC services Ramamurthy Nagar, app development company Ramamurthy Nagar, lead generation company Ramamurthy Nagar, best SEO company in Ramamurthy Nagar"
        url="https://cyborgsapient.com/"
      />
      <OrganizationSchema />
      <Navbar/>
      <HomepageHero />
      <PremiumInfluencer/>
      <div id="services">
        <OurServices/>
      </div>
      <WhyChooseUs/>
      <IndustryExpertise/>
      <HomepageContent/>
      <How/>
      <Testimonial/>
      <FAQ />
      <Footer/>
      {/* <SmsOTPStandalone /> */}
      <PersistentCTA />
      <StickyMobileCTA />
    </div>
  )
}

export default Homepage
